import { render } from "./IconDelete.vue?vue&type=template&id=2e27db4a"
import script from "./IconDelete.vue?vue&type=script&lang=js"
export * from "./IconDelete.vue?vue&type=script&lang=js"
script.render = render

export default script